/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    PostActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

export const createPostEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POST_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PostActions.createdPost))
);

export const createPostV1Epic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POST_CREATE_OLD && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PostActions.createdPostV1))
);

export const fetchPostEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POST_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, PostActions.receivePost))
);

export const uploadPostEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POST_UPLOAD && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PostActions.uploadedPost))
);

export const fetchPostPreviewEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POST_PREVIEW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PostActions.receivePostPreview))
);

export const fetchPostValidatorsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POST_VALIDATORS_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PostActions.receivePostValidators))
);

export const fetchPostMediaValidationEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POST_MEDIA_VALIDATION && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PostActions.receivePostMediaValidation))
);

export const fetchMediaGalleryEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.POST_MEDIA_GALLERY && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, PostActions.receiveMediaGallery))
);
